import { useState } from 'react';
import { Dialog, Typography, IconButton, Link, Box } from '@material-ui/core';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../../../theme';
import SportWiseLogo from '../../../assets/img/SportWiseLogoLarge.png';
import CloseIcon from '@material-ui/icons/Close';

const AuthModal = ({ isOpen, onClose, onSuccess }) => {
	const [authMode, setAuthMode] = useState('signUp');

	const handleToggleAuthMode = () => setAuthMode((prevState) => (prevState === 'signIn' ? 'signUp' : 'signIn'));

	const content = {
		title:
			authMode === 'signIn' ? 'Sign in to make this DataSpace yours' : 'Create an account to make this DataSpace yours',
		description:
			authMode === 'signIn'
				? 'Once you sign in, this DataSpace will be added to your account automatically'
				: 'Once you sign up, this DataSpace will be added to your account automatically',
		form:
			authMode === 'signIn' ? (
				<SignInForm onClose={onClose} onSuccess={onSuccess} />
			) : (
				<SignUpForm onClose={onClose} onSuccess={onSuccess} />
			),
		toggleText: authMode === 'signIn' ? "Don't have an account?" : 'Already have an account?',
		toggleLink: authMode === 'signIn' ? 'Sign Up' : 'Sign In',
	};

	return (
		<ThemeProvider theme={theme}>
			<Dialog open={isOpen} fullWidth>
				<IconButton className="close-button" aria-label="close" onClick={onClose}>
					<CloseIcon sx={{ fontSize: '1rem' }} />
				</IconButton>

				<Box sx={{ textAlign: 'center', mb: 3 }}>
					<img src={SportWiseLogo} alt="SportWise Logo" style={{ height: '3rem', objectFit: 'contain' }} />
				</Box>

				<Typography variant="h3" align="center" sx={{ mb: 1 }}>
					{content.title}
				</Typography>

				<Typography variant="body1" align="center" sx={{ mb: 3 }}>
					{content.description}
				</Typography>

				{content.form}

				<Typography variant="body1" align="center" sx={{ mt: 2 }}>
					{content.toggleText}{' '}
					<Link onClick={handleToggleAuthMode} underline="always" style={{ cursor: 'pointer', color: '#009CC6' }}>
						{content.toggleLink}
					</Link>
				</Typography>
			</Dialog>
		</ThemeProvider>
	);
};

export default AuthModal;
